export default __webpack_public_path__ + "f70c6bb275a52afc9f3bab79970d86e1.png";